export function ArrowIcon() {
  return (
    <svg
      data-testid="arrow-icon"
      width="16"
      height="16"
      viewBox="0 0 640 640"
      fill="currentColor"
    >
      <path d="M598.6 297.4C611.1 309.9 611.1 330.2 598.6 342.7L470.6 470.7C461.4 479.9 447.7 482.6 435.7 477.6C423.7 472.6 416 460.9 416 448L416 384L80 384C53.5 384 32 362.5 32 336L32 304C32 277.5 53.5 256 80 256L416 256L416 192C416 179.1 423.8 167.4 435.8 162.4C447.8 157.4 461.5 160.2 470.7 169.3L598.7 297.3z" />
    </svg>
  );
}
